const initialState = {
  isLoading: true,
  data: {
    playerCaps: null,
    active: [],
    practice: [],
    reserved: [],
  },
  nonActivePlayer: [],
}

const rosterReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case 'SET_ROSTER_LOADING': {
      return {
        ...state,
        isLoading: payload,
      }
    }
    case 'SET_ROSTERS': {
      const nonActive = []
      payload?.active?.forEach((v) => {
        if (v?.isActive !== true) {
          nonActive.push(v?.player_id?._id)
        }
      })
      return {
        ...state,
        data: payload,
        nonActivePlayer: nonActive,
      }
    }
    default:
      return state
  }
}

export default rosterReducer
